<template>
  <div>
    <v-app-bar app color="#292f4c" dark flat>
      <v-app-bar-nav-icon @click="drawer = !drawer" />
      <v-toolbar-title>Painel Administrativo</v-toolbar-title>
      <v-spacer />
      <span class="mr-4 text-body-2">
        {{ userName }}<span v-if="typeLabel"> · {{ typeLabel }}</span>
      </span>
      <v-btn icon title="Sair" @click="logout">
        <v-icon>mdi-logout</v-icon>
      </v-btn>
    </v-app-bar>

    <v-navigation-drawer v-model="drawer" app color="#292f4c" dark>
      <v-list dense nav>
        <v-list-item
          v-for="item in menuItems"
          :key="item.route"
          link
          :to="{ name: item.route }"
        >
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-main class="admin-content">
      <v-container fluid class="pa-6">
        <router-view />
      </v-container>
    </v-main>
  </div>
</template>

<script>
import { getUser, getTypeUser } from '@/utils';
import { TYPE_USER } from '@/utils/enums';

export default {
  name: 'AdminLayout',
  data() {
    return {
      drawer: true,
    };
  },
  computed: {
    userName() {
      return getUser().name || '';
    },
    typeLabel() {
      const labels = {
        [TYPE_USER.SUPER]: 'Administrador',
        [TYPE_USER.DISTRIBUTOR]: 'Distribuidor',
        [TYPE_USER.RESELLER]: 'Revendedor',
      };

      return labels[getTypeUser()] || '';
    },
    menuItems() {
      const type = getTypeUser();
      const items = [
        {
          title: 'Dashboard',
          route: 'admin-dashboard',
          icon: 'mdi-view-dashboard',
          roles: [TYPE_USER.SUPER],
        },
        {
          title: 'Empresas',
          route: 'admin-companies',
          icon: 'mdi-domain',
          roles: [TYPE_USER.SUPER, TYPE_USER.DISTRIBUTOR, TYPE_USER.RESELLER],
        },
        {
          title: 'Revendedores',
          route: 'admin-resellers',
          icon: 'mdi-storefront',
          roles: [TYPE_USER.SUPER, TYPE_USER.DISTRIBUTOR],
        },
        {
          title: 'Saldo a receber',
          route: 'admin-my-recipient-details',
          icon: 'mdi-cash-plus',
          roles: [TYPE_USER.DISTRIBUTOR],
        },
        {
          title: 'Distribuidores',
          route: 'admin-distributors',
          icon: 'mdi-truck',
          roles: [TYPE_USER.SUPER],
        },
      ];

      return items.filter((item) => item.roles.includes(type));
    },
  },
  methods: {
    logout() {
      this.$api.auth.logout().then(() => {
        window.location = `${import.meta.env.VITE_URL}/login`;
      });
    },
  },
};
</script>

<style scoped>
.admin-content {
  background-color: #f6f7fb;
  min-height: 100vh;
}
</style>
